import React from "react";
import CartPage from "../components/CartPage";

const CartList = () => {
    return (
        <>
            <CartPage />
        </>
    )
}

export default CartList;